import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useIsomorphicLayoutEffect } from '../hooks/use-isomorphic-layout-effect';
import { createAtlaskitPortal, createPortalParent } from '../utils/portal-dom-utils';
export default function InternalPortalNew(props) {
  var zIndex = props.zIndex,
    children = props.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    atlaskitPortal = _useState2[0],
    setAtlaskitPortal = _useState2[1];
  useIsomorphicLayoutEffect(function () {
    var tempPortalContainer = createAtlaskitPortal(zIndex);
    setAtlaskitPortal(tempPortalContainer);
    var portalParent = createPortalParent();
    if (!tempPortalContainer || !portalParent) {
      return;
    }
    portalParent.appendChild(tempPortalContainer);
    return function () {
      if (tempPortalContainer) {
        portalParent.removeChild(tempPortalContainer);
      }
      setAtlaskitPortal(null);
    };
  }, [zIndex]);
  return atlaskitPortal ? /*#__PURE__*/createPortal(children, atlaskitPortal) : null;
}